import { toast } from "react-toastify";

export const handleCopyToClipboard = async (shareUrl: string) => {
	try {
		if (navigator.clipboard && window.isSecureContext) {
			// Modern API
			await navigator.clipboard.writeText(shareUrl);
		} else {
			// Fallback for Android & old browsers
			const textArea = document.createElement("textarea");
			textArea.value = shareUrl;
			textArea.style.position = "fixed";
			textArea.style.top = "-9999px";
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			document.execCommand("copy");
			document.body.removeChild(textArea);
		}
		toast.success("Link copied to clipboard", { autoClose: 3000 });
	} catch (err) {
		console.error("Failed to copy: ", err);
	}
};
